
interface RoleObject {
    RoleId: number,
    Role: string
}
interface Roles {
    RolesArray: Array<string>
}
export const userRoles: RoleObject[] =
    [
        {
            RoleId: 1, Role: "Master Admin"
        },
        {
            RoleId: 2, Role: "Admin"
        },
        {
            RoleId: 3, Role: "Project Manager"
        },
        {
            RoleId: 4, Role: "Job Supervisor"
        }
    ];
    



export default userRoles